// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderCartButton_wrapper__UCUqN","textDiv":"HeaderCartButton_textDiv__CNbpx","floatingContentWrapper":"HeaderCartButton_floatingContentWrapper__QLE2q"};